"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRepeatPageContext = void 0;
// @ts-nocheck
const lodash_1 = require("lodash");
const react_1 = __importDefault(require("react"));
const RepeatContext = react_1.default.createContext({
    toggleCollapse: lodash_1.noop,
    repeatCollapsed: false,
});
const RepeatPageWrapper = (props) => {
    const [opened, setOpened] = react_1.default.useState(true);
    const toggleOpened = () => {
        setOpened(!opened);
    };
    // TODO - see what the form renderer can pass down to this wrapper as prop so this doesn't have to feel so hacky
    const firstFieldProp = props.children &&
        // @ts-ignore
        props.children[0] &&
        // @ts-ignore
        props.children[0].props.controlDefinition &&
        // @ts-ignore
        props.children[0].props.controlDefinition.type !== 'group';
    return (react_1.default.createElement(RepeatContext.Provider, { value: { toggleCollapse: toggleOpened, repeatCollapsed: !opened } }, firstFieldProp ? (react_1.default.createElement("div", { style: { marginBottom: 20 } },
        react_1.default.createElement("div", { style: { padding: 0 } },
            react_1.default.createElement("div", { style: { width: '100%' } }, props.children)))) : (props.children)));
};
const useRepeatPageContext = () => react_1.default.useContext(RepeatContext);
exports.useRepeatPageContext = useRepeatPageContext;
exports.default = RepeatPageWrapper;
//# sourceMappingURL=RepeatPageWrapper.js.map